// VAVA angel mark — the real brand asset (public/brand/vava-angel.png).
// Used small in the sidebar brand + on the login / set-password screens; the
// wordmark text sits next to it in those layouts.

export const VavaLogo = ({ size = 28 }) => (
  <img src="/brand/vava-angel.png" width={size} height={size}
       alt="VAVA" className="vava-logo-img"
       style={{ objectFit: 'contain', display: 'block' }} />
);

// Full lockup (angel + vava wordmark + DESIGNER CAKES) for prominent placements
// like the login screen.
export const VavaLockup = ({ width = 200 }) => (
  <img src="/brand/vava-logo.png" width={width}
       alt="VAVA Designer Cakes" className="vava-lockup-img"
       style={{ objectFit: 'contain', display: 'block', height: 'auto' }} />
);
